import {SODeletePeriod} from '../../core/period/so-delete-period';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeletePeriod extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeletePeriod;
}